<template>
  <v-btn fab x-small @click="handleXsCartButtonClick">
    <v-icon>mdi-cart-outline</v-icon>
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'XsCartButton',
  computed: {
    ...mapGetters('auth', { authorized: 'isAuthenticated' })
  },
  methods: {
    handleXsCartButtonClick() {
      if (this.authorized) {
        this.$router.push({ name: 'cart' });
      } else {
        this.$store.commit('cart/SET_UNAUTHENTICATED_CART_BUTTON_CLICK', true);
        this.$router.push({ name: 'login' });
      }
    }
  }
};
</script>
